import axios from "axios";
import authHeader from "./authHeader";
import { apiPath, API_URL } from "./apiPath";
const getJobOfferDropdownItems = (subUrl) => {
  return axios.get(API_URL + subUrl, authHeader()).then((response) => {
    return response.data;
  });
};

const updateJobOfferStatus = (params) => {
  return axios
    .post(API_URL + apiPath.updateJobOfferStatus, params, authHeader())
    .then((response) => {
      return response.data;
    });
};
const getJobWorkerListApi = (params) => {
  return axios
    .post(API_URL + apiPath.getJobWorkerList, params, authHeader())
    .then((response) => {
      return response.data;
    });
};
const updateJobOfferApi = (params) => {
  return axios
    .post(API_URL + apiPath.updateJobOffer, params, authHeader())
    .then((response) => {
      return response.data;
    });
};
const getAgeListForjobApi = () => {
  return axios
    .get(API_URL + apiPath.getAgeListForjob, authHeader())
    .then((response) => {
      return response.data;
    });
};
const getJobStagesApi = () => {
  return axios
    .get(API_URL + apiPath.getJobStages, authHeader())
    .then((response) => {
      return response.data;
    });
};

const newJobOfferApi = {
  getJobOfferDropdownItems,
  updateJobOfferStatus,
  getJobWorkerListApi,
  getJobStagesApi,
  updateJobOfferApi,
  getAgeListForjobApi,
};
export default newJobOfferApi;
